export function authHeader() {
    // return authorization header with jwt token
    let token = localStorage.getItem('token');
    const headers = { 'Content-Type': 'application/json' };
    if (token) {
        headers['Authorization'] = 'Token ' + token;
    }

    return headers;
}